import React, { createContext, useState } from 'react'
import SnackBar from 'src/components/era-package/era/SnackBar';

const SnackbarContext = createContext()

let enqueueSnackbarRef = () => {
  throw new Error('SnackbarProvider is not mounted');
};

export function enqueueSnackbar(message, options) {
  enqueueSnackbarRef(message, options);
}

const getDisplayTitle = (title, severity) => {
  if (title) return title
  if (!severity) return 'Alert'

  return severity.charAt(0).toUpperCase() + severity.slice(1)
}

export const SnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('info')
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [duration, setDuration] = useState(15000)

  const enqueueSnackbar = (message, options) => {
    setTitle(getDisplayTitle(
      options?.title, options?.severity
    ))
    setType(options?.severity || 'info')
    setMessage(message)
    setDuration(options?.duration || 15000)

    setOpen(true)
  }

  // Update the ref on every render
  enqueueSnackbarRef = enqueueSnackbar;

  return <SnackbarContext.Provider value={{ enqueueSnackbar }}>
    <SnackBar
      {...{ title, type, duration }}
      open={open}
      onClose={() => setOpen(false)}
    >
      {message}
    </SnackBar>
    {children}
  </SnackbarContext.Provider>
}